'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _isDOMEvent = require('coact-utils/isDOMEvent');

var _isDOMEvent2 = _interopRequireDefault(_isDOMEvent);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function enhancer(Component) {
  var InputTextCtrl = function (_React$Component) {
    _inherits(InputTextCtrl, _React$Component);

    function InputTextCtrl(props) {
      _classCallCheck(this, InputTextCtrl);

      var _this = _possibleConstructorReturn(this, (InputTextCtrl.__proto__ || Object.getPrototypeOf(InputTextCtrl)).call(this, props));

      _this.state = { value: props.value };
      _this.isDirty = false;

      _this.handleChange = _this.handleChange.bind(_this);
      _this.changeDocValue = _this.changeDocValue.bind(_this);
      return _this;
    }

    _createClass(InputTextCtrl, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // isDirty 不適合放在 state 裡，因為非同步更新
        // input `ff` in number input，props.value will pass `NaN`
        // 但 isDirty 還沒更新，所以不會重設 state.value

        // 上層其他的變動啟動新的 render，若正在編輯中就不更新
        if (this.state.value !== nextProps.value && !this.isDirty) {
          this.setState({ value: nextProps.value });
        }
      }
    }, {
      key: 'handleChange',
      value: function handleChange(input) {
        this.isDirty = true;
        this.setState({ value: (0, _isDOMEvent2.default)(input) ? input.target.value : input });
      }
    }, {
      key: 'changeDocValue',
      value: function changeDocValue() {
        var _this2 = this;

        this.isDirty = false;
        if (this.props.value !== this.state.value) {
          return new Promise(function (resolve) {
            var trimedValue = _this2.state.value.trim();
            _this2.props.onChange(trimedValue, resolve);
          });
        }
        return Promise.resolve();
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, {
          value: this.state.value,
          onChange: this.handleChange,
          changeDocValue: this.changeDocValue,
          isDirty: this.isDirty
        }));
      }
    }]);

    return InputTextCtrl;
  }(_react2.default.Component);

  InputTextCtrl.propTypes = {
    value: _propTypes.string,
    onChange: _propTypes.func.isRequired
  };

  return InputTextCtrl;
}

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'controlInputValue');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/controlInputValue.js
// module id = 1730
// module chunks = 0